import { UploadFileHeaders } from '../../../../../types/uploadFilesHeaders'

export const getUploadAttachmentOptions = (organizationId: string): Partial<UploadFileHeaders> => ({
  'x-create-attachment': true,
  'x-organizationId': organizationId,
  'x-should-scan': true,
  'x-create-variants': true,
})
